var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1734_42104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5996 3.41406C17.5669 3.41406 21.5996 7.44681 21.5996 12.4141C21.5996 17.3813 17.5669 21.4141 12.5996 21.4141C7.63236 21.4141 3.59961 17.3813 3.59961 12.4141C3.59961 7.44681 7.63236 3.41406 12.5996 3.41406ZM6.74361 7.71344C5.70898 9.00081 5.08948 10.6354 5.08948 12.4141C5.08948 16.5589 8.45473 19.9242 12.5996 19.9242C14.3782 19.9242 16.0129 19.3047 17.2999 18.2701L6.74361 7.71344ZM18.3866 17.1991C19.4629 15.8993 20.1101 14.2317 20.1101 12.4141C20.1101 8.26881 16.7449 4.90356 12.5996 4.90356C10.782 4.90356 9.11436 5.55081 7.81461 6.62706L18.3866 17.1991Z",
    fill: "#545B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1734_42104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.431641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectStories);
export default __webpack_public_path__ + "static/media/reject-stories.9c4d6c2ec2cc42feb96261289a1f51dc.svg";
export { ForwardRef as ReactComponent };